import { XlsxParserConfig } from 'apprise-frontend-parse/context';

export const avlmigrationConfig: XlsxParserConfig = {

    headerCornerstone: 'vtype',
    allowMissingCornerstone: undefined!,

    keys: {

        iotc: { key: "uvi" },
        date: { key: "date" },
        tropical: { key: 'tropical', aliases: { 'na': undefined } },
        swordfish: { key: 'swordfish', aliases: { 'na': undefined } },
        flag: { key: "flagstate" },
        year: { key: "year" },
        target_species: {key: 'species'},
        name_charterer: { key: "charterer", aliases: { "UNKNOWN": undefined, "Not Applicable": undefined } },
        address_charterer: { key: "charterer_address", aliases: { "UNKNOWN": undefined, "Not Applicable": undefined } }

    }


    ,

    type: {

        external: {


            keys: {

                imo: { key: 'imo' },
                name: { key: 'name' },
                nat_reg: { key: 'regno' },
                call_sign: { key: 'ircs', aliases: { 'unk': undefined, 'Unknown': undefined } },
                flag: { key: 'flagstate', filter: v => v !== 'UNK' },
                type_ship: {key: 'type'},
                type_gear: {key: 'gear'},
                target_species: {key: 'species'},
                'loa': { key: 'loa' },
                'grt': { key: 'grt' },
                'gt': { key: 'tonnage' },

                'name_owner': { key: 'owner', aliases: { 'UNKNOWN*': undefined } },
                'address_owner': { key: 'ownerAddress', aliases: { 'UNKNOWN': undefined } },
                'name_operator': { key: 'operator', aliases: { 'UNKNOWN': undefined } },
                'address_operator': { key: 'operatorAddress', aliases: { 'UNKNOWN': undefined } }

            }
        }

    }

}

